/* global process */
/**
 * REST API URLs
 *
 * @author MKA
 * Last changed: 05.12.2023
 * Changes: Added endpoints
 */

//unselect all selected IDs in editor for performance

// Relative by default so the built image works in any environment: the browser
// calls the same origin that served it, and nginx proxies /api -> api sidecar.
// For local dev, set REACT_APP_URL=http://localhost:5000/api/v1 in .env.local.
export const URL = process.env.REACT_APP_URL || '/api/v1';
export const URL_AUTH = URL + '/auth';
export const URL_USERS = URL + '/users';
export const URL_MANUAL = URL + '/users/manual/link';
export const URL_FORGOT = URL + '/auth/reset';
export const URL_LABELS = URL + '/labels';
export const URL_TEMPLATES = URL + '/labels/templates';
export const URL_CUSTOMERS = URL + '/customers';
export const URL_EVENTS = URL + '/events';
export const URL_LOCATIONS = URL + '/locations'; // Replace with the actual endpoint
export const URL_IMAGES = URL + '/images';
export const URL_IMAGES_BLOB = URL + '/images/blob';
export const URL_MATCHINGS = URL + '/labels/write'; // Replace with the actual endpoint
export const URL_MATCHINGS_BULK = URL + '/labels/write/bulk'; // Replace with the actual endpoint
export const URL_MATCHINGS_CLEAR = URL + '/labels/clear'; // Replace with the actual endpoint
export const URL_SCHEDULES = URL + '/schedules'; // Replace with the actual endpoint
